import { isCustomerListFiltered, isProdMode } from './../utils/app-common';
import { AxiosError } from 'axios';
import { getNotificationStyle } from '../common/notification';
import { IBooking, IBulkPrint, ICashCustomerAccount, ICountryCityWithOutAgreement, ICreateSubWaybillsRequest, IFetchFiles, IGoogleRequest, IOriginDestinationRequest, IPickupException, IProofOfDeliveryRequest, IRejectException, IReschedule, IShipperAndAccountDetailRequest, IShipperRequest, ISubWaybillPrint, IUpdateBookingStatus, IValidAgreementDetailRequest, UpdateConsigneeLocationRequest } from '../model/BookingModel';
import { IFilter } from '../model/CommonModel';
import { UploadFormData } from '../stores/common';
import AjexPortalService from "./api";
import config from './config';
import { IChangeDeliveryDate, IDWSChangeDeliveryDate, IUpdatePickUpDetails } from '../model/OperationModel';

const tmsPricingService = process.env.REACT_APP_TMS_PRICING_SERVICE;

const booking = config.get('booking');
const customer = config.get('customer');
const product = config.get('product');
const productIdQuery = config.get('productId');
const subProductIdQuery = config.get('subProductId');
const subProduct = config.get('subProduct');
const temperature = config.get('temperature');
const shipper = config.get('shipper');
const customerSubAccount = config.get('customerSubAccount');
const consignee = config.get('consignee');
const clientSubId = config.get('clientSubId');
const cancel = config.get('cancel');
const subCLientIdQuery = config.get('subCLientIdQuery');
const subClientQuery = config.get('subClientQuery');
const cashCustomer = config.get('cashCustomer');
const tree = config.get('tree');
const filter = config.get('filter');
const podFileOptions = config.get('podFileOptions');
const pod = config.get('pod');
const updateGoogleAddress = config.get('updateGoogleAddress');
const tracking = config.get('tracking');
const vehicle = config.get('vehicle');
const all = config.get('all');
const address = config.get('address');
const countryCity = config.get('countryCity');
const excelBulkBooking = config.get('excelBulkBooking');
const download = config.get('download');
const updateBookingStatusField = config.get('updateBookingStatusField');
const plateNo = config.get('plateNo');
const bookingReschedulePickup = config.get('bookingReschedulePickup');
const updatePickupDate = config.get('updatePickupDate');
const countryCityWithOutAgreement = config.get('countryCityWithOutAgreement');
const cityConsignee = config.get('cityConsignee');
const city = config.get('city');
const cityShipper = config.get('cityShipper');
const newManualSticker = config.get('newManualSticker');
const print = config.get('print');
const newManualWaybill = config.get('newManualWaybill');
const productDescription = config.get('productDescription');
const uploadMultipleFile = config.get('uploadMultipleFile');
const fileAttachment = config.get('fileAttachment');
const updateFile = config.get('updateFile');
const downloadByCategory = config.get('downloadByCategory');
const category = config.get('category');
const deleteFile = config.get('deleteFile');
const station = config.get('station');
const manual = config.get('manual');
const salesman = config.get('salesman');
const salesPerson = config.get('salesPerson');
const pickupException = config.get('pickupException');
const pickup = config.get('pickup');
const reject = config.get('reject');
const operation = config.get('operation');
const dispatchWorkstation = config.get('dispatchWorkstation');
const findValidAgreementDetail = config.get('findValidAgreementDetail');
const getPickupDateHistory = config.get('getPickupDateHistory');
const businessGroup = config.get('businessGroup');
const employee = config.get('employee');
const occ = config.get('occ');
const rto = config.get('rto');
const reportURL = process.env.REACT_APP_TMS_REPORT_SERVICE;
const commonURL = process.env.REACT_APP_TMS_COMMON_SERVICE
const readURL = process.env.REACT_APP_TMS_READ_SERVICE;
const occURL = process.env.REACT_APP_TMS_OCC_SERVICE;

export const GetBookingListService = async (filteredData: Partial<IFilter>) => {
    try {
        return await AjexPortalService.post(`${booking}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const GetCustomerByIdService = async (isFinance: boolean, id?: number) => {
    try {
        return await AjexPortalService.get(`${customer}?isFinance=${isProdMode() ? isFinance : true}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetCustomerBySalesPersonService = async () => {
    try {
        return await AjexPortalService.get(`${customer}/${salesPerson}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetAllSubProductService = async () => {
    try {
        return await AjexPortalService.get(`${subProduct}/${all}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const GetAllTemperatureService = async () => {
    try {
        return await AjexPortalService.get(`${temperature}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const GetProductsService = async (subId: number) => {
    try {
        return await AjexPortalService.get(`${product}/${subClientQuery}/${subId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetAllProductsService = async () => {
    try {
        return await AjexPortalService.get(`${product}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetTemperatureByIdService = async (productId: number, subProductId: number, subClientId: number) => {
    try {
        return await AjexPortalService.get(`${temperature}/sub-product?${productIdQuery}=${productId}&${subProductIdQuery}=${subProductId}&${subCLientIdQuery}=${subClientId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetShipperDetailsByIdService = async (id: number) => {
    try {

        return await AjexPortalService.get(`${shipper}/${clientSubId}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const GetFtlShipperDetailsByIdService = async (id: number, isFtl: boolean) => {
    try {

        return await AjexPortalService.get(`${shipper}/ftl-client-sub-id/${id}?isFtl=${isFtl}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const GetConsigneeDetailsByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${consignee}/${clientSubId}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetFtlConsigneeDetailsByIdService = async (id: number, isFtl: boolean) => {
    try {
        return await AjexPortalService.get(`${consignee}/ftl-client-sub-id/${id}?isFtl=${isFtl}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetConsigneeDetailsByShipperAndAccountDetailsService = async (request: IShipperAndAccountDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/city/city-consignee
        if (!request?.subclientId) return;

        return await AjexPortalService.post(`${city}/${cityConsignee}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const GetShipperDetailsByAccountDetailsService = async (request: Omit<IShipperAndAccountDetailRequest, 'originCityId'>) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/city/city-consignee
        if (!request?.subclientId) return;
        return await AjexPortalService.post(`${city}/${cityShipper}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}
export const SaveBookingService = async (data: IBooking) => {
    try {
        return await AjexPortalService.post(`${booking}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


export const SaveShipperService = async (data: IShipperRequest) => {
    try {
        return await AjexPortalService.post(`${shipper}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const SaveShipperSubCityService = async (data: IShipperRequest) => {
    try {
        return await AjexPortalService.put(`${shipper}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const SaveConsigneeService = async (data: IShipperRequest) => {
    try {
        return await AjexPortalService.post(`${consignee}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const SaveSubCityConsigneeService = async (data: IShipperRequest) => {
    try {
        return await AjexPortalService.put(`${consignee}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetBookingDetailByIdService = async (id?: number) => {
    try {
        return await AjexPortalService.get(`${booking}/${id}`,)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const UpdateBookingDetailService = async (id: number | undefined, data: IBooking) => {
    try {
        return await AjexPortalService.put(`${booking}/${id}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const CancelBookingByIdService = async (id: number | undefined, request?: { cancelReasonId: null, cancelRemarks?: undefined }) => {
    try {
        return await AjexPortalService.put(`${booking}/${cancel}/${id}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const CancelRtoWaybillService = async (waybillNo: string) => {
    try {
        return await AjexPortalService.put(`${commonURL}${rto}/${cancel}/${encodeURIComponent(waybillNo.trim())}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetAccountNameByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${customerSubAccount}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer-sub-account/info/53
export const GetAccountDetailByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${customerSubAccount}/info/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetProductSubProductTemperatureDetailsService = async (id: number) => {
    try {
        if (!id) return;
        return await AjexPortalService.get(`${product}/${tree}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const GetProofOfDeliveryService = async () => {
    try {
        //pod-file-options
        return await AjexPortalService.get(`${commonURL}${podFileOptions}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const SaveProofOfDeliveryService = async (data: IProofOfDeliveryRequest) => {
    try {
        //pod-file-options
        return await AjexPortalService.post(`${pod}`, data)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }

}

export const DeleteProofOfDeliveryService = async (id: number | undefined) => {
    try {
        //pod-file-options
        return await AjexPortalService.delete(`${pod}/${id}`,)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }

}

export const UpdateShipperGoogleAddressService = async (data: IGoogleRequest) => {
    try {
        //pod-file-options
        return await AjexPortalService.put(`${shipper}/${updateGoogleAddress}`, data)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}


export const UpdateConsigneeGoogleAddressService = async (data: IGoogleRequest) => {
    try {
        return await AjexPortalService.put(`${consignee}/${updateGoogleAddress}`, data)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const TrackWayBillService = async (airWayBillNumber: string) => {
    try {
        // return await AjexPortalService.get(`${vehicle}/${tracking}/${airWayBillNumber}`)
        return await AjexPortalService.get(`${occURL}${occ}/${tracking}/${airWayBillNumber}`,)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const TrackVehicleByPlateNumberService = async (plateNumber: string) => {
    try {
        return await AjexPortalService.get(`${vehicle}/${plateNo}/${plateNumber}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const GetCustomerAccountService = async () => {
    try {
        return await AjexPortalService.get(`${cashCustomer}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const SaveCashCustomerService = async (data: ICashCustomerAccount) => {
    try {
        return await AjexPortalService.post(`${cashCustomer}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetCustomerAddressByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${cashCustomer}/${address}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetOriginDestinationCountryCityService = async (request: IOriginDestinationRequest) => {
    try {
        return await AjexPortalService.post(`${countryCity}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const UploadBulkBooingService = async (file: any) => {
    try {
        const { formData, configuration } = UploadFormData(file)
        return await AjexPortalService.post(`${excelBulkBooking}`, formData, configuration)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadBookingExcelService = async () => {
    try {
        return await AjexPortalService.get(`${download}/${booking}.xlsx`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const UpdateBookingStatusService = async (rowId: number | undefined, request: IUpdateBookingStatus) => {
    try {
        return await AjexPortalService.put(`${booking}/${updateBookingStatusField}/${rowId}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}



export const BookingRescheduleService = async (request: IReschedule) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/booking-reschedule-pickup/update-pickup-date
        return await AjexPortalService.put(`${bookingReschedulePickup}/${updatePickupDate}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetCountryWithOutAgreementService = async (request: ICountryCityWithOutAgreement) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/country-city-with-out-agreement
        return await AjexPortalService.post(`${countryCityWithOutAgreement}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const PrintBulkWayBillService = async (waybills: IBulkPrint) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/new-manual-waybill
        return await AjexPortalService.post(`${readURL}/${print}/${newManualWaybill}`, waybills)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const PrintBulkStickerService = async (waybills: IBulkPrint) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/new-waybill-sticker
        return await AjexPortalService.post(`${commonURL}/${print}/${newManualSticker}`, waybills)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

//https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/upload-multiple-file
export const UploadFileService = async (request: { formData: FormData, configuration: {} }) => {
    try {
        return await AjexPortalService.post(`${commonURL}${fileAttachment}/${uploadMultipleFile}`, request?.formData, request?.configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}
//https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/download-by-category?waybillNo=A1010003108&category=booking&fileType=Create Booking File
export const GetUploadedFileListService = async (request: IFetchFiles) => {
    try {
        return await AjexPortalService.get(`${commonURL}${fileAttachment}/${downloadByCategory}?waybillNo=${request?.waybillNo}&${category}=${request?.category}&fileType=${request?.fileType}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/product-description/download?productId=5
export const ProductDescriptionByProductIdService = async (request: number) => {
    try {
        return await AjexPortalService.get(`${productDescription}/${download}?${productIdQuery}=${request}`)
    } catch (error) {
        const err = error as AxiosError;
        // getNotificationStyle(err?.response);
        return err?.response
    }
}


//https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/delete-file/639
export const DeleteFileByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${commonURL}${fileAttachment}/${deleteFile}/${id}`)
    } catch (error) {
        const err = error as AxiosError;
        // getNotificationStyle(err?.response);
        return err?.response
    }
}
//https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/update-file
export const UpdateFileService = async (request: { formData: FormData, configuration: {} }) => {
    try {
        return await AjexPortalService.put(`${commonURL}${fileAttachment}/${updateFile}`, request?.formData, request?.configuration)
    } catch (error) {
        const err = error as AxiosError;
        // getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetCustomerBySalesManIdService = async (id?: number) => {
    try {
        return await AjexPortalService.get(`${reportURL}${customer}/${salesman}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetAllStationsService = async () => {
    try {
        return await AjexPortalService.get(`${station}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const GetShippersByClientAndOriginService = async (clientSubId: number, originCityId: number) => {
    try {
        return await AjexPortalService.get(`${shipper}/${manual}/${clientSubId}/${originCityId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

export const GetConsigneesByClientService = async (clientSubId: number) => {
    try {
        return await AjexPortalService.get(`${consignee}/${manual}/${clientSubId}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}



//https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/update-file


///api/v1/shipper/manual/update-shipper/{id}

export const UpdateBookingShipperDetailsAction = async (request?, id?: number) => {
    try {
        return await AjexPortalService.put(`shipper/manual/update-shipper/${id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
///api/v1/consignee/manual/update-consignee/{id}

export const UpdateBookingConsigneeDetailsAction = async (request?, id?: number) => {
    try {
        return await AjexPortalService.put(`consignee/manual/update-consignee/${id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

//booking/update
export const UpdateBookingPickUpDetailsService = async (request?: IUpdatePickUpDetails) => {
    try {
        return await AjexPortalService.put(`booking/update`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const GetCustomerByFilterService = async (filter?: string | undefined, isFiltered?: boolean | undefined) => {
    try {
        // return await AjexPortalService.get(`https://apps-sit.aj-ex.com/tms-report-service/api/v1/customer?filter=${filter}`)
        return await AjexPortalService.get(`${customer}/${salesPerson}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }

}

//https://apps.aj-ex.com/tms-common-service/api/v1/pickup/pickup-exception
export const PickupExceptionService = async (request: IPickupException) => {
    try {
        return await AjexPortalService.post(`${commonURL}${pickup}/${pickupException}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }

}

//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/booking/reject
export const RejectExceptionService = async (request: IRejectException) => {
    try {
        return await AjexPortalService.post(`${booking}/${reject}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }

}

//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/operation/dispatch-workstation
export const DispatchWorkStationService = async (request: Partial<IFilter>) => {
    try {
        return await AjexPortalService.post(`${operation}/${dispatchWorkstation}/new`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }

}

// Booking service v2 base, derived from the v1 base URL (…/tms-booking-service/api/v2/)
const bookingServiceV2 = process.env.REACT_APP_API_BASE_URL?.replace(/\/api\/v1\/?$/, '/api/v2/');

//https://apps-sit.aj-ex.com/tms-booking-service/api/v2/operation/dispatch-workstation
export const DispatchWorkStationV2Service = async (request: Partial<IFilter>) => {
    try {
        return await AjexPortalService.post(`${bookingServiceV2}${operation}/${dispatchWorkstation}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }

}

export const GetValidAgreementDetailService = async (request: IValidAgreementDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1//find-valid-agreement-detail
        if (!request || !request.clientId || !request.productId || !request.subProductId || !request.temperatureId) {
            console.error("Invalid request: ", request);
            return;
        }
        return await AjexPortalService.post(`${booking}/${findValidAgreementDetail}`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
// http://localhost:6200/api/v1/booking-reschedule-pickup/get-pickup-date-history/3576
export const GetRescheduleDetailService = async (bookingID?: number) => {
    try {
        return await AjexPortalService.get(`${bookingReschedulePickup}/${getPickupDateHistory}/${bookingID}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response
    }
}

// https://apps.aj-ex.com/tms-booking-service/api/v1/shipper/14618
export const GetShipperDetailService = async (shipperID) => {
    try {
        return await AjexPortalService.get(`${shipper}/${shipperID}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

// https://apps.aj-ex.com/tms-booking-service/api/v1/consignee/41262
export const GetConsigneeDetailService = async (consigneeID) => {
    try {
        return await AjexPortalService.get(`${consignee}/${consigneeID}`)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const GetAllBusinessGroupsService = async () => {
    try {
        return await AjexPortalService.get(`${businessGroup}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

// https://apps-sit.aj-ex.com/tms-booking-service/api/v1/booking/booking-reschedule
export const DWSBookingRescheduleService = async (request?: IDWSChangeDeliveryDate) => {
    try {
        return await AjexPortalService.put(`booking/booking-reschedule`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const GetReporteesService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${employee}/employees-reported-to/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
// tms-booking-service/api/v1/consignee/update-consignee/
export const UpdateConsigneePhoneNumberService = async (request, id) => {
    try {
        return await AjexPortalService.put(`consignee/update-consignee/${id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const CreateSubWaybillsService = async (request: ICreateSubWaybillsRequest) => {
    try {
        return await AjexPortalService.post(`additional-shipper-consignee`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetSubWaybillsService = async (waybillNo: string) => {
    try {
        return await AjexPortalService.get(`additional-shipper-consignee/sub-waybills?waybillNo=${waybillNo}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const PrintSubWaybillService = async (data: ISubWaybillPrint) => {
    try {
        return await AjexPortalService.post(`${readURL}/${print}/sub-waybill`, data)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
export const PrintSubWaybillStickerService = async (data: ISubWaybillPrint) => {
    try {
        return await AjexPortalService.post(`${commonURL}/${print}/sub-waybill-sticker`, data)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetCommodityListService = async (request: IValidAgreementDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-pricing-service/api/v1/commodity/agreement-commodity
        return await AjexPortalService.post(`${tmsPricingService}commodity/agreement-commodity`, request)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const ChangeDeliveryDateService = async (request) => {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/delivery-date-history
    try {
        return await AjexPortalService.put(`${commonURL}delivery-date-history`, request);

    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetDeliveryDateListService = async (id) => {
    try {

        return await AjexPortalService.get(`delivery-reschedule/get-delivery-date-history/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const GetDeliveryRescheduleByClientService = async (param) => {
    try {
        // delivery-reschedule/get-not-ofd-waybills-paginated?startDate=2024-01-03&endDate=2025-04-12&clientSubId=53
        const params = new URLSearchParams();
        if (param?.startDate) params.append('startDate', param?.startDate);
        if (param?.endDate) params.append('endDate', param?.endDate);
        // if (param?.clientSubId) params.append('clientSubId', '53');
        if (param?.clientSubId) params.append('clientSubId', param?.clientSubId?.toString());
        if (param?.waybillNo) params.append('waybillNo', param?.waybillNo);
        if (param?.page) params.append('page', param?.page);
        if (param?.size) params.append('size', param?.size);
        params.append('userId', param.userId);

        return await AjexPortalService.get(`delivery-reschedule/get-not-ofd-waybills-paginated?${params.toString()}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const UpdateChangeRescheduleDateService = async (payload) => {
    try {
        // https://apps-sit.aj-ex.com/tms-booking-service/api/v1/delivery-reschedule
        return await AjexPortalService.put(`delivery-reschedule/${payload?.deliveryRescheduleId}`, payload)
    }
    catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}




export const UpdateConsigneeLocationService = async (data: UpdateConsigneeLocationRequest) => {
    try {
        return await AjexPortalService.post(
            `${process.env.REACT_APP_TMS_COMMON_SERVICE}consignee-location`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

// GET: https://apps-sit.aj-ex.com/tms-booking-service/api/v1/pod-checklist
export const GetPodChecklistService = async () => {
    try {
        return await AjexPortalService.get(`pod-checklist`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const UpdateShipperByIdV2Service = async (request: any, id: number) => {
    try {
        return await AjexPortalService.put(`${shipper}/update-shipper/${id}`, request);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}

export const UpdateConsigneeByIdV2Service = async (request: any, id: number) => {
    try {
        return await AjexPortalService.put(`${consignee}/update-consignee/${id}`, request);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response
    }
}
